export default __webpack_public_path__ + "static/media/search-icon-blue.aaa1c09a.svg";